const day = 'day';
const week = 'week';
const month = 'month';

export {
    day, week, month,
};
